import React from 'react';
import classNames from 'classnames';

import { useIntl } from '../../util/reactIntl';

import css from './NewListingBadge.module.css';

/**
 * A component that renders a "New Listing" badge for recently created listings.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @returns {JSX.Element}
 */
const NewListingBadge = props => {
  const intl = useIntl();
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  const badgeText = intl.formatMessage({ id: 'NewListingBadge.label' });

  return (
    <div className={classes}>
      {badgeText}
    </div>
  );
};

export default NewListingBadge;